var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockplayerBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.993A1 1 0 012.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 01-.992.993H2.992A.993.993 0 012 20.007V3.993zm8.622 4.422a.4.4 0 00-.622.332v6.506a.4.4 0 00.622.332l4.879-3.252a.4.4 0 000-.666l-4.88-3.252z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+PHBhdGggZD0iTTIgMy45OTNBMSAxIDAgMCAxIDIuOTkyIDNoMTguMDE2Yy41NDggMCAuOTkyLjQ0NS45OTIuOTkzdjE2LjAxNGExIDEgMCAwIDEtLjk5Mi45OTNIMi45OTJBLjk5My45OTMgMCAwIDEgMiAyMC4wMDdWMy45OTN6bTguNjIyIDQuNDIyYS40LjQgMCAwIDAtLjYyMi4zMzJ2Ni41MDZhLjQuNCAwIDAgMCAuNjIyLjMzMmw0Ljg3OS0zLjI1MmEuNC40IDAgMCAwIDAtLjY2NmwtNC44OC0zLjI1MnoiLz48L3N2Zz4=";
export { SvgBlockplayerBlock as ReactComponent };